import { CurrencyCode } from '@noths/polaris-dev-ts-types';

import { TrackingProductData } from 'src/tracking/common/products';
import { RRDecoratedRecommendationsServiceProductData } from 'src/types/RichRelevance';

export const mapProductToTrackingProduct = (
  {
    new: isNew,
    on_sale: onSale,
    sale_percentage: salePercentage,
    prices,
    free_domestic_delivery: freeDomesticDelivery,
    ...product
  }: RRDecoratedRecommendationsServiceProductData,
  currency: CurrencyCode,
) =>
  ({
    isNew,
    onSale,
    salePercentage,
    freeDomesticDelivery,
    price: prices.find((prices) => prices.currency === currency),
    ...product,
  } as TrackingProductData);
